import React from 'react';
import StatisticsFilter from '../StatisticsFilter';
import StatisticsTZSelector from '../StatisticsTZSelector';
import StatisticsDateFilter from '../StatisticsDateFilter/StatisticsDateFilter';
import StatisticsSubIdsFilters from '../StatisticsSubIdsFilters/StatisticsSubIdsFilters';
import StatisticsPresets from '../StatisticsPresets';
import { Button, Collapse } from 'reactstrap';
// import { OffersListFilters } from '../../Offers/OffersListFilters';
import { OffersFilterView } from '../../Offers';
import StatisticsRefreshButton from '../StatisticsRefreshButton';
import StatisticsSettings from '../StatisticsSettings';
import StatisticsExport from '../StatisticsExport/StatisticsExport';
// import { categories } from '../../../services/ApiService';
import { FormattedMessage } from 'react-intl';

const View = ({
  data: {
    presets,
    sources,
    countries,
    onRefresh,
    intl,
    key,
    filters,
    preset,
    dateTo,
    dateFrom,
    timeZone,
    stats,
    total,
    type,
    currency,
    onSettingsUpdate,
    collapse,
    windowWidth,
  },
  getSubIdsLabel,
  getLabel,
  getChangingFilterOptions,
  onTimezoneChange,
  onDateChange,
  filterApplyHandler,
  onCategoriesChange,
  onSourceChange,
  filterClearHandler,
  onOfferChange,
  onSubIdsChange,
  subsDisabled,
  onFlowChange,
  onStatusChange,
  onCountryChange,
  onSelectPreset,
  onRemovePreset,
  onSavePreset,
  getSitesOptions,
  getOffersOptions,
  getCategoriesOptions,
  getStreamsOptions,
  isCollapsing,
  isMembers,
  isAggregated,
  slavesList,
  toggleCollapse,
  categories,
  onCategoriesReset,
  onBuyersChange,
  buyersOptions
}) => {
  const normalizedStatuses = Array.isArray(filters.statuses)
    ? filters.statuses.map(Number)
    : String(filters.statuses || '')
        .split(',')
        .filter(Boolean)
        .map(Number);
  const selectedStatusGroups = [];

  if (normalizedStatuses.some((status) => status !== 10)) {
    selectedStatusGroups.push('native');
  }
  if (normalizedStatuses.includes(10)) {
    selectedStatusGroups.push('transferred');
  }

  return (
    <div key={key} className="statistics-filters">
      <span className="statistics-filters-collapse-text">Фильтры</span>
      {/* {!isCollapsing && (
        <Button color="primary" size="sm" type="button" onClick={toggleCollapse}>
          <span className="statistics-filters-collapse-sign">{collapse ? '- ' : '+ '}</span>
          Фильтры
        </Button>
      )} */}
      {/* windowWidth > 0 Чтобы не прыгало при загрузке пока ширина неизвестна */}
      {windowWidth > 0 && (
        <Collapse isOpen={collapse || !isCollapsing}>
          {/* Часовой пояс */}
          {/* <StatisticsTZSelector onTimezoneChange={onTimezoneChange} timezone={timeZone} /> */}

          {/* Фильтр по дате */}
          <StatisticsDateFilter
            startDate={dateFrom}
            endDate={dateTo}
            onFilterChange={onDateChange}
            onFilterApply={filterApplyHandler}
          />

          {/* Фильтр по площадкам */}
          {/* {!isMembers && (
            <StatisticsFilter
              id="source_filter"
              getLabel={() => getLabel('Sources')}
              value={filters.sources}
              options={sources.map(({ title: label, id: value }) => ({
                value,
                label,
              }))}
              onFilterChange={onSourceChange}
              onFilterApply={filterApplyHandler}
              onFilterClear={filterClearHandler}
              name="sources"
              multiple
              loadOptions={getSitesOptions}
              deferLoad
            />
          )} */}

          {/* Фильтр по категориям */}
          {/* {!isMembers && (
            <>
              <OffersFilterView
                id="categories_filter"
                name="categories"
                defaultLabel={intl.formatMessage({
                  id: 'statistics.filters.categories',
                  defaultMessage: 'Categories',
                })}
                items={categories}
                search
                onFilterChange={onCategoriesChange}
                children={
                  <div className="filter-popover-controls">
                    <Button size="sm" color="primary" onClick={filterApplyHandler}>
                      <FormattedMessage defaultMessage="Apply" id="statistics.filters.apply" />
                    </Button>
                    <Button size="sm" color="light" onClick={onCategoriesReset}>
                      <FormattedMessage defaultMessage="Clear" id="statistics.filters.clear" />
                    </Button>
                  </div>
                }
              />
            </>
          )} */}

          {/* Пользовательские настройки */}
          <StatisticsPresets
            selected={preset}
            presets={presets}
            onSelectPreset={onSelectPreset}
            onRemovePreset={onRemovePreset}
            onSavePreset={onSavePreset}
            mobileModal={windowWidth < 768}
          />

          {/* Фильтр по офферам */}
          <StatisticsFilter
            id="offer_filter"
            getLabel={() => getLabel('Offers')}
            value={filters.offers}
            options={getChangingFilterOptions('offers')}
            onFilterChange={onOfferChange}
            onFilterApply={filterApplyHandler}
            onFilterClear={filterClearHandler}
            name="offers"
            multiple
            loadOptions={getOffersOptions}
            deferLoad
            mobileModal={windowWidth < 768}
          />

          {/* Фильтр по SubId */}
          <StatisticsSubIdsFilters
            id="subids_filter"
            preselected={filters}
            slavesList={isMembers ? slavesList : null}
            getLabel={() => getSubIdsLabel('SubID')}
            onFilterChange={onSubIdsChange}
            onFilterApply={filterApplyHandler}
            onFilterClear={filterClearHandler}
            name="subId1"
            placeholder={intl.formatMessage({
              id: 'statistics.filters.subids.placeholder',
              defaultMessage: "Select SubID's",
            })}
            disabled={subsDisabled}
          />

          {/* Фильтр по потокам */}
          <StatisticsFilter
            id="flows_filter"
            getLabel={() => getLabel('Flows')}
            value={filters.flows}
            options={getChangingFilterOptions('flows')}
            onFilterChange={onFlowChange}
            onFilterApply={filterApplyHandler}
            onFilterClear={filterClearHandler}
            name="flows"
            multiple
            loadOptions={getStreamsOptions}
            deferLoad
            mobileModal={windowWidth < 768}
          />

          {/* Фильтр по статусам */}
          <StatisticsFilter
            id="statuses_filter"
            getLabel={() => getLabel('Statuses')}
            value={selectedStatusGroups}
            options={[
              {
                value: 'native',
                label: intl.formatMessage({
                  id: 'statistics.filters.statuses.native',
                  defaultMessage: 'Native',
                }),
              },
              {
                value: 'transferred',
                label: intl.formatMessage({
                  id: 'statistics.filters.statuses.transferred',
                  defaultMessage: 'Transferred',
                }),
              },
            ]}
            onFilterChange={onStatusChange}
            onFilterApply={filterApplyHandler}
            onFilterClear={filterClearHandler}
            name="statuses"
            multiple
            mobileModal={windowWidth < 768}
          />

          {/* Фильтр по странам */}
          {/* {!isMembers && (
            <StatisticsFilter
              id="country_filter"
              getLabel={() => getLabel('Countries')}
              value={filters.countries}
              options={countries.map(({ title: label, id: value }) => ({
                value,
                label,
              }))}
              onFilterChange={onCountryChange}
              onFilterApply={filterApplyHandler}
              onFilterClear={filterClearHandler}
              name="countries"
              multiple
            />
          )} */}

          {/* Фильтр по баерам (мастер: все табы общей статистики + список аккаунтов) */}
          {isMembers && buyersOptions.length > 0 && (
            <StatisticsFilter
              id="buyers_filter"
              getLabel={() => getLabel('Buyers')}
              value={filters.buyers}
              options={buyersOptions}
              onFilterChange={onBuyersChange}
              onFilterApply={filterApplyHandler}
              onFilterClear={filterClearHandler}
              name="buyers"
              multiple
              mobileModal={windowWidth < 768}
            />
          )}
        </Collapse>
      )}
    </div>
  );
};

export default View;
